import React, {useEffect, useState} from 'react'
import clinicService from '../../../../../services/clinic.service'
import {toast} from 'react-toastify'
import {useParams} from 'react-router-dom'
import {useForm} from 'react-hook-form';

const AssetForm = ({assets, getAssets}) => {
    const {register, handleSubmit, formState: {errors}} = useForm(
        {
            defaultValues: assets
        }
    )
    const onSubmit = (data) => {
        clinicService.saveAssets(data.clinicId, data)
            .then(res => {
                getAssets()
                toast.success("Updated Assets", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            })
            .catch(err => {
                toast.error("Error while updating", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            })
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="input-group">
                <input type="text" placeholder='Directory Name' {...register("directory")}
                       className="form-control mt-2 mb-2"/>
            </div>
            <div className="p-1"></div>
            <button className="btn btn-sm btn-success" type="submit"><i className="bi bi-floppy"></i> Save</button>
        </form>
    )
}

function AssetsCard() {
    const {clinicId} = useParams()
    const [assets, setAssets] = useState(null)
    const [edit, setEdit] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        clinicService.getAssets(clinicId)
            .then(res => {
                setAssets(res.data)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                setLoading(false)
            })
    }, [])

    const getAssets = () => {
        setLoading(true)
        clinicService.getAssets(clinicId)
            .then(res => {
                setAssets(res.data)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                setLoading(false)
            })
    }
    return (
        <>
            <div className="card card-padding shadow-none card-border">
                <div className="card-title">
                    <div className="d-flex justify-content-between align-items-center">
                        <div><i className='bi bi-folder'></i> Assets Directory</div>
                        <button
                            className={`btn btn-sm ${edit ? 'btn-outline-danger' : 'btn-outline-primary'}`}
                            onClick={() => setEdit(!edit)}
                        >
                            <i className={`bi ${edit ? 'bi-x' : 'bi-pencil-square'}`}></i> {edit ? 'Cancel' : 'Edit'}
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    {assets && <>{edit ? <AssetForm assets={assets} getAssets={getAssets}/> : assets.directory} </>}
                </div>
            </div>
        </>
    )
}

export default AssetsCard